"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _Events = _interopRequireWildcard(require("../constants/Events"));
var _ConfigStoreConstants = require("../constants/ConfigStoreConstants");
var _CallbackTypes = _interopRequireWildcard(require("../constants/CallbackTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ /* eslint class-methods-use-this: 0 */
class EventsService {
  constructor() {
    this._handleEvent = this._handleEvent.bind(this);
    this._previewRef = undefined;
    this._eventListenerMap = {};
    this._pageInViewSent = 0;
    this._currentZoom = 0;
  }

  /**
   * @method
   * @description
   * Register an event to be notified for
   * @param {String} eventType event type
   * @param {Function} eventListener other event info like fileName
   *
   */
  registerEventListener(eventType, eventListener) {
    if (!this._eventListenerMap[eventType]) {
      this._eventListenerMap[eventType] = [];
    }
    this._eventListenerMap[eventType].push(eventListener);
  }
  _getTopbarActionEventType() {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    return config.isViewSDKPublic ? _Events.CoreEvents.CUSTOMIZE_TOP_BAR : _Events.default.ACTION_ICONS;
  }

  /**
   * @method
   * @description
   * initialize the event listener for multiple events like scroll, zoom, mouse movement etc.
   *
   * @param {Object} previewRef reference to the dc preview component
   */
  initialize(previewRef) {
    if (this._previewRef) {
      return;
    }
    this._previewRef = previewRef;
    const listenEvent = (eventEmitter, from, to) => {
      eventEmitter.on(from, this._handleEvent(to));
    };
    const eventListener = (from, to) => listenEvent(this._previewRef.events, from, to);
    this._previewRef.getApis("INT_EVENTS", ["documentEvents"]).then(apiObject => {
      const oldListener = (from, to) => listenEvent(apiObject.documentEvents, from, to);
      oldListener("pagesViewScrolled", _Events.FilePreviewEvents.PREVIEW_PAGE_VIEW_SCROLLED);
      oldListener("zoom", _Events.FilePreviewEvents.PREVIEW_ZOOM);
      oldListener("selectionend", _Events.FilePreviewEvents.PREVIEW_SELECTION_END);
      oldListener("keydown", _Events.FilePreviewEvents.PREVIEW_KEY_DOWN);
      oldListener("documentclick", _Events.FilePreviewEvents.PREVIEW_DOCUMENT_CLICK);
      oldListener("pageclick", _Events.FilePreviewEvents.PREVIEW_PAGE_CLICK);
      oldListener("pagedblclick", _Events.FilePreviewEvents.PREVIEW_PAGE_DOUBLE_CLICK);
      oldListener("pagehover", _Events.FilePreviewEvents.PREVIEW_PAGE_HOVER);
      oldListener("fullScreenViewEntry", _Events.FilePreviewEvents.FULL_SCREEN_VIEW_ENTRY);
      oldListener("fullScreenViewExit", _Events.FilePreviewEvents.FULL_SCREEN_VIEW_EXIT);
    });
    eventListener("pagemouseenter", _Events.FilePreviewEvents.PREVIEW_PAGE_MOUSE_ENTER);
    eventListener("pagemouseleave", _Events.FilePreviewEvents.PREVIEW_PAGE_MOUSE_LEAVE);
    eventListener("currentpagechange", _Events.FilePreviewEvents.CURRENT_ACTIVE_PAGE);
    eventListener("pagesinviewchange", _Events.FilePreviewEvents.PAGES_IN_VIEW_CHANGE);
    eventListener("unsupportedfeaturefound", _Events.FilePreviewEvents.UNSUPPORTED_FEATURE_FOUND);
    eventListener("errorOccurred", _Events.FilePreviewEvents.PREVIEW_ERROR_EVENTS);
    eventListener("editPreprocessingInitiated", _Events.FilePreviewEvents.EDIT_PRE_PROCESSING_INITIATED);
    eventListener("documentviewupdate", _Events.InternalEvents.DOCUMENT_VIEW_UPDATE);
    eventListener("documentViewThemeChange", _Events.FilePreviewEvents.DOCUMENT_VIEW_THEME_CHANGE);
    eventListener("customizetopbar", this._getTopbarActionEventType());
    eventListener("completePDFBufferAvailable", _Events.default.PDF_VIEWER_READY);
    eventListener("submitform", _Events.FilePreviewEvents.SUBMIT_FORM);
    eventListener("editEnterSuccessful", _Events.FilePreviewEvents.EDIT_ENTER_SUCCESSFUL);
    eventListener("handleEnterEdit", _Events.FilePreviewEvents.HANDLE_ENTER_EDIT);
    eventListener("handleEditUpsell", _Events.FilePreviewEvents.HANDLE_EDIT_UPSELL);
    eventListener("handleEditKeyboardShortcut", _Events.FilePreviewEvents.HANDLE_EDIT_KEYBOARD_SHORTCUT);
    eventListener("handleEditLocalFontPrimingDialogEvents", _Events.FilePreviewEvents.HANDLE_EDIT_LOCAL_FONT_PRIMING_DIALOG_EVENTS);
    eventListener("openDocumentInDesktop", _Events.FilePreviewEvents.OPEN_DOCUMENT_IN_DESKTOP);
    eventListener("handleOpenNativeApp", _Events.FilePreviewEvents.HANDLE_OPEN_NATIVE_APP);
    eventListener("contextMenuItemClicked", _Events.FilePreviewEvents.CONTEXT_MENU_ITEM_CLICKED);
    eventListener("genAIOperationPerformed", _Events.FilePreviewEvents.GENAI_OPERATION_PERFORMED);
    eventListener("digSigValidationStatusUpdated", _Events.FilePreviewEvents.DIGITAL_SIGNATURE_VALIDATION_STATUS_UPDATED);
    eventListener("editToolsUsed", _Events.FilePreviewEvents.EDIT_TOOLS_USED);
    eventListener("fallbackprint", _Events.FilePreviewEvents.FALLBACK_PRINT);
    eventListener("waitingOnCompletePDFBuffer", _Events.FilePreviewEvents.WAITING_ON_COMPLETE_PDF_BUFFER);
    eventListener("documentViewStateUpdate", _Events.InternalEvents.DOCUMENT_VIEW_STATE_UPDATE);
    eventListener("touchStart", _Events.FilePreviewEvents.TOUCH_START);
    eventListener("touchEnd", _Events.FilePreviewEvents.TOUCH_END);

    // PDF Analytics events
    eventListener("documentopen", _Events.PDFAnalyticsEvents.DOCUMENT_OPEN);
    eventListener("documentdownload", _Events.PDFAnalyticsEvents.DOCUMENT_DOWNLOAD);
    eventListener("documentprint", _Events.PDFAnalyticsEvents.DOCUMENT_PRINT);
    eventListener("textsearch", _Events.PDFAnalyticsEvents.TEXT_SEARCH);
    eventListener("bookmarkitemclick", _Events.PDFAnalyticsEvents.BOOKMARK_ITEM_CLICK);
    eventListener("hyperlinkopen", _Events.PDFAnalyticsEvents.HYPERLINK_OPEN);
    eventListener("textcopy", _Events.PDFAnalyticsEvents.TEXT_COPY);
  }

  /**
   * @method
   * @description
   * send the current page view event analytics
   *
   * @param {Object} eventData eventData have current page view info
   */
  _handlePageViewEvent(eventData) {
    if (eventData.startPage && eventData.endPage) {
      const start = eventData.startPage.pageNumber;
      const end = eventData.endPage.pageNumber;
      let pageInView = start;
      while (pageInView <= end) {
        if (this._pageInViewSent !== pageInView) {
          this.sendEvent(_Events.PDFAnalyticsEvents.PAGE_VIEW, {
            pageNumber: pageInView
          });
          this._pageInViewSent = pageInView;
        }
        pageInView += 1;
      }
    }
  }

  /**
   * @method
   * @description
   * handling the special analytics case like change in pageView, zoom etc
   *
   * @param {Object} eventType type of event
   * @param {Object} eventData values associated with the event.
   */
  _handlePDFAnalyticsSpecialCases(eventType, eventData) {
    if (eventType === _Events.FilePreviewEvents.PAGES_IN_VIEW_CHANGE) {
      this._handlePageViewEvent(eventData);
    } else if (eventType === _Events.FilePreviewEvents.PREVIEW_ZOOM && this._currentZoom !== eventData) {
      this._currentZoom = eventData;
      this.sendEvent(_Events.PDFAnalyticsEvents.ZOOM_LEVEL, {
        zoomLevel: eventData
      });
    }
  }
  _handleEvent(eventType) {
    return eventData => {
      if (eventType === _Events.InternalEvents.DOCUMENT_VIEW_UPDATE) {
        _ServiceRegistry.default.getService("AppStore").documentViewUpdate = eventData;
      }
      this._handlePDFAnalyticsSpecialCases(eventType, eventData);
      this.sendEvent(eventType, this._filterData(eventType, eventData));
    };
  }

  /**
   * @method
   * @description
   * formate the event data on the basis of eventType filter
   *
   * @param {Object} eventType type of event
   * @param {Object} eventData values associated with the event.
   *
   * @return {Object} event object
   */
  _filterData(eventType, eventData) {
    if (eventType === _Events.FilePreviewEvents.PREVIEW_PAGE_CLICK || eventType === _Events.FilePreviewEvents.PREVIEW_PAGE_DOUBLE_CLICK || eventType === _Events.FilePreviewEvents.PREVIEW_PAGE_HOVER) {
      return _objectSpread({
        pageNumber: eventData.params.pageIndex + 1
      }, eventData.params);
    }
    if (eventType === _Events.FilePreviewEvents.PREVIEW_DOCUMENT_CLICK) {
      return {
        pageX: eventData.pageX,
        pageY: eventData.pageY,
        screenX: eventData.screenX,
        screenY: eventData.screenY,
        clientX: eventData.clientX,
        clientY: eventData.clientY
      };
    }
    if (eventType === _Events.FilePreviewEvents.PREVIEW_KEY_DOWN) {
      return {
        altKey: eventData.altKey,
        code: eventData.code,
        composed: eventData.composed,
        ctrlKey: eventData.ctrlKey,
        key: eventData.key,
        keyCode: eventData.keyCode,
        location: eventData.location,
        metaKey: eventData.metaKey,
        shiftKey: eventData.shiftKey,
        type: eventData.type
      };
    }
    if (eventType === _Events.FilePreviewEvents.PREVIEW_PAGE_VIEW_SCROLLED) {
      if (!eventData || !eventData.target) {
        return {};
      }
      return {
        clientHeight: eventData.target.clientHeight,
        clientWidth: eventData.target.clientWidth,
        scrollHeight: eventData.target.scrollHeight,
        scrollLeft: eventData.target.scrollLeft,
        scrollTop: eventData.target.scrollTop,
        scrollWidth: eventData.target.scrollWidth
      };
    }
    if (eventType === _Events.FilePreviewEvents.PREVIEW_PAGE_MOUSE_ENTER || eventType === _Events.FilePreviewEvents.PREVIEW_PAGE_MOUSE_LEAVE) {
      if (!eventData || !eventData.params) {
        return {};
      }
      return {
        pageNumber: eventData.params.pageIndex + 1
      };
    }
    if (eventType === _Events.FilePreviewEvents.PREVIEW_SELECTION_END) {
      const startPageNumber = eventData.startPage + 1;
      const endPageNumber = eventData.endPage + 1;
      const data = {
        startPageNumber,
        endPageNumber,
        newSelection: eventData.newSelection,
        selections: {}
      };
      for (let i = startPageNumber; i <= endPageNumber; i += 1) {
        data.selections[`page${i}`] = eventData[`page${i - 1}`];
      }
      return _objectSpread(_objectSpread({}, eventData), data);
    }
    if (eventType === _Events.default.ACTION_ICONS) {
      const appStore = _ServiceRegistry.default.getService("AppStore");
      const toolsConfig = {
        topbarConfig: eventData.topbarConfig || [],
        layoutConfig: eventData.layoutConfig || {}
      };
      if (appStore.getActionConfig("preview").showAnnotationTools && appStore.isEditAllowed) {
        if (!appStore.enableModernViewer) {
          let tools = _ServiceRegistry.default.getService("CommentsApi").getTopBarTools();
          if (!appStore.textSelectionEnabled) {
            tools = tools.filter(tool => [_Events.AnnotationTypes.HIGHLIGHT, _Events.AnnotationTypes.STRIKEOUT, _Events.AnnotationTypes.UNDERLINE].indexOf(tool.id) === -1);
          }
          const customTopBarTools = _ServiceRegistry.default.getService("CommentsApi").getCustomTopBarTools();
          toolsConfig.topbarConfig = tools.concat(toolsConfig.topbarConfig);
          toolsConfig.layoutConfig = _objectSpread(_objectSpread({}, toolsConfig.layoutConfig), {}, {
            customTopBarTools
          });
          toolsConfig.toolbar = _ServiceRegistry.default.getService("CommentsApi").getToolbar();
        }
      } else {
        toolsConfig.topbarConfig = toolsConfig.topbarConfig.filter(val => _ConfigStoreConstants.ANNOTATION_TOOL_IDS.indexOf(val.id) === -1);
      }
      return _objectSpread(_objectSpread({}, eventData), toolsConfig);
    }
    if (eventType === _Events.CoreEvents.CUSTOMIZE_TOP_BAR) {
      const appStore = _ServiceRegistry.default.getService("AppStore");
      let topbarConfig = eventData.topbarConfig;
      if (appStore.getActionConfig("preview").showAnnotationTools && appStore.isEditAllowed) {
        let tools = _ServiceRegistry.default.getService("CommentsApi").getTopBarTools();
        if (!appStore.textSelectionEnabled) {
          tools = tools.filter(tool => [_Events.AnnotationTypes.HIGHLIGHT, _Events.AnnotationTypes.STRIKEOUT, _Events.AnnotationTypes.UNDERLINE].indexOf(tool.id) === -1);
        }
        topbarConfig = tools.filter(val => _ConfigStoreConstants.ANNOTATION_TOOL_IDS.indexOf(val.id) !== -1).concat(topbarConfig);
      }
      return _objectSpread(_objectSpread({}, eventData), {}, {
        topbarConfig
      });
    }
    if (eventType === _Events.FilePreviewEvents.PREVIEW_ERROR_EVENTS) {
      this.handlePreviewErrorEvents(eventData);
    }
    return eventData;
  }
  _stopCoreEvents(eventType) {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    return config.isViewSDKPublic ? _Events.CoreEvents[eventType] : false;
  }

  /**
   * @method
   * @description
   * it formate the event data and notifies if any listener is registered for the event.Event can be
   * related to internal, pdfviewer, annotation and so on.
   *
   * @param {String} eventType event type
   * @param {Object} eventData other event info like value, custom event
   */
  sendEvent(eventType, eventData = {}) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (this._sendCondition() || appStore.appRenderingBlocked && (_Events.FilePreviewEvents[eventType] || _Events.default[eventType] || _Events.PDFAnalyticsEvents[eventType])) {
      return;
    }
    if (this._eventListenerMap[eventType] && this._eventListenerMap[eventType].length > 0) {
      this._eventListenerMap[eventType].forEach(eventListener => eventListener(eventData));
    }
    if (this._stopCoreEvents(eventType)) {
      return;
    }
    let eData = eventData;
    if (_Events.PDFAnalyticsEvents[eventType]) {
      eData = _objectSpread(_objectSpread({}, eventData), {}, {
        fileName: appStore.fileInfoList[0].metaData.fileName
      });
    }
    const data = {
      type: eventType,
      data: eData
    };
    this._sendHelper(data);
  }
  _sendCondition() {
    return _ServiceRegistry.default.getService("AppStore").appClosed;
  }
  _sendHelper(data) {
    _ServiceRegistry.default.getService("EventHandlerService").handleEvent(data);
  }
  handlePreviewErrorEvents(eventData) {
    if (eventData && eventData.errorInfo) {
      const callbackService = _ServiceRegistry.default.getService("CallbackService");
      if (callbackService.hasCallback(_CallbackTypes.default.EDIT_EVENT_HANDLER)) {
        const callbackFn = callbackService.getCallback(_CallbackTypes.default.EDIT_EVENT_HANDLER);
        callbackFn(_CallbackTypes.EditEventTypes.EDIT_ERROR_EVENTS, eventData.errorInfo);
      }
    }
  }
}
exports.default = EventsService;